/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { Autocomplete, TextField } from '@mui/material';
import { isEmpty } from 'modules/common/helpers/object';
import { selectAllHotelList } from 'modules/scenario/selectors';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const HotelFilter = ({ value, onChange }) => {
  const hotelList = useSelector(selectAllHotelList);
  const [allHotelOption, setAllHotelOption] = useState(null);

  // Initialize allHotelOption with "All" for each key when hotelList is available and allHotelOption is empty
  useEffect(() => {
    if (isEmpty(allHotelOption) && hotelList.length > 0) {
      const allHotelObject = {};
      Object.keys(hotelList[0]).forEach((key) => {
        allHotelObject[key] = 'All';
      });
      setAllHotelOption(allHotelObject);
    }
  }, [hotelList, allHotelOption]);

  const options = allHotelOption ? [allHotelOption, ...(hotelList ?? [])] : hotelList ?? [];
  const selectedHotel = options?.find((option) => option.label === value);

  const handleHotelsChange = (event, selected) => {
    onChange?.(selected?.label);
  };

  return (
    <Autocomplete
      sx={{ width: { sm: 350 }, pb: { sm: 2, md: 0, lg: 0 } }}
      size="small"
      options={options}
      value={selectedHotel ?? null}
      getOptionLabel={(option) => option?.label ?? ''}
      isOptionEqualToValue={(option, val) => option?.id === val?.id}
      onChange={handleHotelsChange}
      disableClearable
      renderInput={(params) => (
        <TextField {...params} label="Select Hotel" size="small" color="primary" />
      )}
      fullWidth
      componentsProps={{
        paper: {
          sx: {
            minWidth: 350,
            whiteSpace: 'unset',
            wordBreak: 'break-all',
          },
        },
      }}
    />
  );
};

export default HotelFilter;
